module.exports = __webpack_public_path__ + "static/media/shape-circle.fc79a5c4.svg";